import { render, staticRenderFns } from "./CardNovoItem.vue?vue&type=template&id=42cbd204&scoped=true&"
import script from "./CardNovoItem.vue?vue&type=script&lang=js&"
export * from "./CardNovoItem.vue?vue&type=script&lang=js&"
import style0 from "./CardNovoItem.vue?vue&type=style&index=0&id=42cbd204&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cbd204",
  null
  
)

export default component.exports